module.exports = __webpack_public_path__ + "img/core.d0d5375d.jpeg";